<template>
  <v-row>
    <v-col cols="6">
      <v-text-field
        v-model="inputedValue.saleNumber"
        :placeholder="inputedValue.placeholders[0]"
        outlined
        dense
        hide-details
        :height="height"
      >
      </v-text-field>
    </v-col>
    <v-col>
      <v-text-field
        v-model="inputedValue.remittanceNumber"
        :placeholder="inputedValue.placeholders[1]"
        outlined
        dense
        hide-details
        :height="height"
      >
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {
    //
  },
  props: {
    value: {},
    placeholders: {
      type: Array,
      require: true,
      default: () => []
    },
    height: {
      type: String,
      require: false,
      default: '32px'
    }
  },
  data: () => ({
    items: []
  }),
  created() {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
